var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// @ts-nocheck
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Box, Button, Card, CardContent, CircularProgress, Container, Divider, Grid, Typography, useMediaQuery, useTheme, } from "@mui/material";
import ICSLogo from "../../assets/logos/iCogSci Logo_Design 1a-5_v2.0(241209)-04resize.png";
import englishMessages from "../../i18n/en";
import chineseMessages from "../../i18n/zh-HK";
import { dbDateHelper } from "../../utils/helper";
import "../../styles/global.module.css";
var ApiBaseUrl = import.meta.env.VITE_API_BASE_URL;
var DIGIT_COUNT = 6;
var SYSTEM_ACCENT = "#4d6a95";
var normalizeShareLanguage = function (language) {
    if (!language)
        return "en";
    var normalized = String(language).trim().toLowerCase();
    if (normalized === "zh-hk" || normalized === "zh" || normalized.startsWith("zh-")) {
        return "zh-HK";
    }
    return "en";
};
var parseLocaleFromSearch = function (searchParams) {
    return normalizeShareLanguage(searchParams.get("lang") || searchParams.get("language"));
};
var getShareReportPageMessages = function (locale) {
    var _a, _b, _c;
    var catalog = locale === "zh-HK" ? chineseMessages : englishMessages;
    return (_c = (_b = (_a = catalog === null || catalog === void 0 ? void 0 : catalog.pages) === null || _a === void 0 ? void 0 : _a.exam) === null || _b === void 0 ? void 0 : _b.shareReportPage) !== null && _c !== void 0 ? _c : englishMessages.pages.exam.shareReportPage;
};
var isTruthyFlag = function (value) {
    return value === true || value === "true" || value === 1 || value === "1";
};
var unwrapSharePayload = function (data) {
    if (!data || typeof data !== "object")
        return data;
    if (data.data && typeof data.data === "object") {
        return __assign(__assign({}, data), data.data);
    }
    return data;
};
var parsePasswordRequired = function (data) {
    var _a, _b, _c, _d, _e, _f;
    var payload = unwrapSharePayload(data);
    if (!payload || typeof payload !== "object")
        return false;
    var candidates = [
        payload.password_required,
        payload.passwordRequired,
        (_a = payload.share) === null || _a === void 0 ? void 0 : _a.password_required,
        (_b = payload.share) === null || _b === void 0 ? void 0 : _b.passwordRequired,
        (_c = payload.qr_share) === null || _c === void 0 ? void 0 : _c.password_required,
        (_d = payload.qrShare) === null || _d === void 0 ? void 0 : _d.password_required,
        (_e = payload.exam_qr_share) === null || _e === void 0 ? void 0 : _e.password_required,
        (_f = payload.exam) === null || _f === void 0 ? void 0 : _f.password_required,
    ];
    return candidates.some(isTruthyFlag);
};
var parseErrorMessage = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var text, json;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, response.text()];
            case 1:
                text = _a.sent();
                if (!text)
                    return [2 /*return*/, ""];
                try {
                    json = JSON.parse(text);
                    if (typeof json === "string")
                        return [2 /*return*/, json];
                    return [2 /*return*/, json.message || json.error || text];
                }
                catch (error) {
                    return [2 /*return*/, text];
                }
                return [2 /*return*/];
        }
    });
}); };
var normalizeShareInfo = function (data) {
    var _a, _b, _c, _d;
    var payload = unwrapSharePayload(data);
    var subject = (payload === null || payload === void 0 ? void 0 : payload.subject) || {};
    var exam = (payload === null || payload === void 0 ? void 0 : payload.exam) || payload || {};
    return {
        subjectId: subject.customId ||
            (payload === null || payload === void 0 ? void 0 : payload.subject_customId) ||
            exam.subject_customId ||
            "-",
        examDate: exam.exam_date || (payload === null || payload === void 0 ? void 0 : payload.exam_date),
        aiModel: exam.ai_model || (payload === null || payload === void 0 ? void 0 : payload.ai_model),
        eye: exam.eye || (payload === null || payload === void 0 ? void 0 : payload.eye),
        expiresAt: (payload === null || payload === void 0 ? void 0 : payload.expires_at) || ((_a = payload === null || payload === void 0 ? void 0 : payload.share) === null || _a === void 0 ? void 0 : _a.expires_at),
        downloadLimit: (_d = (_b = payload === null || payload === void 0 ? void 0 : payload.download_limit) !== null && _b !== void 0 ? _b : (_c = payload === null || payload === void 0 ? void 0 : payload.share) === null || _c === void 0 ? void 0 : _c.download_limit) !== null && _d !== void 0 ? _d : null,
        passwordRequired: parsePasswordRequired(payload),
    };
};
var InfoRow = function (_a) {
    var label = _a.label, value = _a.value;
    return (_jsxs(Grid, { container: true, spacing: 1, sx: { py: 0.75 }, children: [_jsx(Grid, { item: true, xs: 12, sm: 4, children: _jsx(Typography, { className: "small-text", color: "text.secondary", children: label }) }), _jsx(Grid, { item: true, xs: 12, sm: 8, children: _jsx(Typography, { className: "small-text normal-bold", children: value || "-" }) })] }));
};
var SharePasswordInput = function (_a) {
    var value = _a.value, onChange = _a.onChange, disabled = _a.disabled, isMobile = _a.isMobile;
    var inputRefs = useRef([]);
    var updateValue = function (next) {
        onChange(next.replace(/\D/g, "").slice(0, DIGIT_COUNT));
    };
    var handleChange = function (index, event) {
        var _a;
        var raw = event.target.value.replace(/\D/g, "");
        var chars = Array.from({ length: DIGIT_COUNT }, function (_, i) { return value[i] || ""; });
        if (!raw) {
            chars[index] = "";
            updateValue(chars.join(""));
            return;
        }
        chars[index] = raw.slice(-1);
        updateValue(chars.join(""));
        if (index < DIGIT_COUNT - 1) {
            (_a = inputRefs.current[index + 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var handleKeyDown = function (index, event) {
        var _a;
        if (event.key !== "Backspace")
            return;
        event.preventDefault();
        var chars = Array.from({ length: DIGIT_COUNT }, function (_, i) { return value[i] || ""; });
        if (value[index]) {
            chars[index] = "";
            updateValue(chars.join(""));
            return;
        }
        if (index > 0) {
            chars[index - 1] = "";
            updateValue(chars.join(""));
            (_a = inputRefs.current[index - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var handlePaste = function (event) {
        var _a;
        event.preventDefault();
        var pasted = event.clipboardData
            .getData("text")
            .replace(/\D/g, "")
            .slice(0, DIGIT_COUNT);
        if (!pasted)
            return;
        updateValue(pasted);
        (_a = inputRefs.current[Math.min(pasted.length, DIGIT_COUNT - 1)]) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var boxSize = isMobile ? 34 : 38;
    return (_jsx(Box, { sx: {
            display: "flex",
            justifyContent: "center",
            gap: { xs: 0.4, sm: 0.6 },
            width: "100%",
            maxWidth: { xs: "100%", sm: 280 },
            mx: "auto",
            px: { xs: 0.5, sm: 0 },
        }, onPaste: handlePaste, children: Array.from({ length: DIGIT_COUNT }).map(function (_, index) {
            var _a;
            return (_jsx(Box, { component: "input", ref: function (el) {
                    inputRefs.current[index] = el;
                }, type: "text", inputMode: "numeric", autoComplete: "one-time-code", pattern: "[0-9]*", maxLength: 1, value: (_a = value[index]) !== null && _a !== void 0 ? _a : "", disabled: disabled, "aria-label": "Digit ".concat(index + 1, " of ").concat(DIGIT_COUNT), onChange: function (event) { return handleChange(index, event); }, onKeyDown: function (event) { return handleKeyDown(index, event); }, onFocus: function (event) { return event.target.select(); }, sx: {
                    width: boxSize,
                    height: boxSize,
                    minWidth: 0,
                    flex: { xs: "1 1 0", sm: "0 0 auto" },
                    maxWidth: boxSize,
                    p: 0,
                    border: "1px solid #dde3ea",
                    borderRadius: "4px",
                    textAlign: "center",
                    fontSize: isMobile ? "1rem" : "1.125rem",
                    fontWeight: 600,
                    color: "#1a2b42",
                    bgcolor: "#fff",
                    outline: "none",
                    WebkitAppearance: "none",
                    "&:focus": {
                        borderColor: SYSTEM_ACCENT,
                        boxShadow: "0 0 0 2px rgba(77, 106, 149, 0.18)",
                    },
                    "&:disabled": {
                        bgcolor: "#f5f5f5",
                    },
                } }, index));
        }) }));
};
var parsePasswordRequiredFromSearch = function (searchParams) {
    return isTruthyFlag(searchParams.get("password_required")) ||
        isTruthyFlag(searchParams.get("pwd"));
};
var parseShareChannelFromSearch = function (searchParams) {
    var channel = (searchParams.get("channel") || "qr").trim().toLowerCase();
    return channel === "email" ? "email" : "qr";
};
var parseShareRecordIdFromSearch = function (searchParams) {
    return searchParams.get("share_record_id") || searchParams.get("shareRecordId") || "";
};
var buildShareApiQuery = function (_a) {
    var channel = _a.channel, shareRecordId = _a.shareRecordId, password = _a.password;
    var params = new URLSearchParams();
    params.set("channel", channel);
    if (shareRecordId) {
        params.set("share_record_id", shareRecordId);
    }
    if (password) {
        params.set("password", password);
    }
    return params.toString();
};
var ShareReportPage = function () {
    var token = useParams().token;
    var searchParams = useSearchParams()[0];
    var passwordRequiredFromUrl = useMemo(function () { return parsePasswordRequiredFromSearch(searchParams); }, [searchParams]);
    var shareChannel = useMemo(function () { return parseShareChannelFromSearch(searchParams); }, [searchParams]);
    var shareRecordId = useMemo(function () { return parseShareRecordIdFromSearch(searchParams); }, [searchParams]);
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var locale = useMemo(function () { return parseLocaleFromSearch(searchParams); }, [searchParams]);
    var t = useMemo(function () { return getShareReportPageMessages(locale); }, [locale]);
    var _a = useState("loading"), status = _a[0], setStatus = _a[1];
    var _b = useState(null), shareInfo = _b[0], setShareInfo = _b[1];
    var _c = useState(false), isDownloading = _c[0], setIsDownloading = _c[1];
    var _d = useState(""), downloadError = _d[0], setDownloadError = _d[1];
    var _e = useState(""), password = _e[0], setPassword = _e[1];
    var _f = useState(passwordRequiredFromUrl), passwordRequired = _f[0], setPasswordRequired = _f[1];
    var showPasswordField = passwordRequired;
    useEffect(function () {
        setPasswordRequired(passwordRequiredFromUrl);
        setPassword("");
        setDownloadError("");
    }, [token, passwordRequiredFromUrl, shareChannel, shareRecordId]);
    useEffect(function () {
        if (!token) {
            setStatus("error");
            return;
        }
        if (!shareRecordId) {
            setStatus("error");
            return;
        }
        var loadShareInfo = function () { return __awaiter(void 0, void 0, void 0, function () {
            var infoQuery, response, data, normalized, resolvedPasswordRequired, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        infoQuery = buildShareApiQuery({
                            channel: shareChannel,
                            shareRecordId: shareRecordId,
                        });
                        return [4 /*yield*/, fetch("".concat(ApiBaseUrl, "/sharing/report/").concat(token, "/info?").concat(infoQuery), {
                                method: "GET",
                                headers: { Accept: "application/json" },
                            })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) {
                            if (response.status === 404) {
                                setShareInfo({ passwordRequired: passwordRequiredFromUrl });
                                setPasswordRequired(passwordRequiredFromUrl);
                                setStatus("ready");
                                return [2 /*return*/];
                            }
                            setStatus(response.status === 410 || response.status === 403 ? "expired" : "error");
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, response.json()];
                    case 2:
                        data = _a.sent();
                        normalized = normalizeShareInfo(data);
                        resolvedPasswordRequired = normalized.passwordRequired || passwordRequiredFromUrl;
                        setShareInfo(__assign(__assign({}, normalized), { passwordRequired: resolvedPasswordRequired }));
                        setPasswordRequired(resolvedPasswordRequired);
                        setStatus("ready");
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        setStatus("error");
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadShareInfo();
    }, [token, passwordRequiredFromUrl, shareChannel, shareRecordId]);
    var getDownloadErrorMessage = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var message, lowerMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, parseErrorMessage(response)];
                case 1:
                    message = (_a.sent()).trim();
                    lowerMessage = message.toLowerCase();
                    if (response.status === 401) {
                        setPasswordRequired(true);
                        if (lowerMessage.includes("required")) {
                            return [2 /*return*/, t.passwordRequired];
                        }
                        if (lowerMessage.includes("invalid")) {
                            return [2 /*return*/, t.invalidPassword];
                        }
                        return [2 /*return*/, message || t.invalidPassword];
                    }
                    if (response.status === 400 && lowerMessage.includes("password")) {
                        setPasswordRequired(true);
                        return [2 /*return*/, message || t.invalidPasswordFormat];
                    }
                    return [2 /*return*/, message || t.downloadError];
            }
        });
    }); };
    var handleDownload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedPassword, downloadQuery, response, _a, blob, pdfBlob, disposition, filenameMatch, filename, blobUrl_1, link, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!token || isDownloading)
                        return [2 /*return*/];
                    trimmedPassword = password.trim();
                    if (showPasswordField) {
                        if (!trimmedPassword) {
                            setDownloadError(t.passwordRequired);
                            return [2 /*return*/];
                        }
                        if (!/^\d{6}$/.test(trimmedPassword)) {
                            setDownloadError(t.invalidPasswordFormat);
                            return [2 /*return*/];
                        }
                    }
                    setIsDownloading(true);
                    setDownloadError("");
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    downloadQuery = buildShareApiQuery({
                        channel: shareChannel,
                        shareRecordId: shareRecordId,
                        password: showPasswordField ? trimmedPassword : "",
                    });
                    return [4 /*yield*/, fetch("".concat(ApiBaseUrl, "/sharing/report/").concat(token, "?").concat(downloadQuery), {
                            method: "GET",
                            headers: { Accept: "application/pdf" },
                        })];
                case 2:
                    response = _b.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    _a = setDownloadError;
                    return [4 /*yield*/, getDownloadErrorMessage(response)];
                case 3:
                    _a.apply(void 0, [_b.sent()]);
                    if (response.status === 410 || response.status === 403 || response.status === 404) {
                        setStatus("expired");
                    }
                    return [2 /*return*/];
                case 4: return [4 /*yield*/, response.blob()];
                case 5:
                    blob = _b.sent();
                    pdfBlob = blob.type === "application/pdf"
                        ? blob
                        : new Blob([blob], { type: "application/pdf" });
                    disposition = response.headers.get("Content-Disposition") || "";
                    filenameMatch = disposition.match(/filename="?([^"]+)"?/i);
                    filename = (filenameMatch === null || filenameMatch === void 0 ? void 0 : filenameMatch[1]) || "brain-health-report.pdf";
                    blobUrl_1 = URL.createObjectURL(pdfBlob);
                    link = document.createElement("a");
                    link.href = blobUrl_1;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    setTimeout(function () { return URL.revokeObjectURL(blobUrl_1); }, 120000);
                    return [3 /*break*/, 8];
                case 6:
                    error_2 = _b.sent();
                    console.error(error_2);
                    setDownloadError(t.downloadError);
                    return [3 /*break*/, 8];
                case 7:
                    setIsDownloading(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return (_jsx(Box, { sx: {
            minHeight: "100vh",
            bgcolor: "#ebeff2",
            py: { xs: 2, sm: 4 },
            px: { xs: 1.5, sm: 2 },
        }, children: _jsx(Container, { maxWidth: "sm", children: _jsx(Card, { sx: {
                    borderRadius: 0,
                    boxShadow: "0 2px 8px rgba(77, 106, 149, 0.18)",
                    overflow: "hidden",
                }, children: _jsxs(CardContent, { sx: { p: { xs: 2, sm: 3 } }, children: [_jsx(Box, { display: "flex", justifyContent: "center", mb: 2, children: _jsx("img", { src: ICSLogo, alt: "i-Cog logo", style: {
                                    height: isMobile ? 88 : 110,
                                    width: "auto",
                                    maxWidth: "100%",
                                } }) }), _jsx(Typography, { className: "normal-bold", align: "center", color: "#4d6a95", sx: { mb: 0.5 }, children: t.platform }), _jsx(Typography, { className: "large-bold", align: "center", color: "black", sx: { mb: 2 }, children: t.title }), _jsx(Divider, { sx: { mb: 2 } }), status === "loading" && (_jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", py: 4, children: [_jsx(CircularProgress, { size: 36, sx: { mb: 2 } }), _jsx(Typography, { className: "small-text", children: t.loading })] })), status === "ready" && shareInfo && (_jsxs(_Fragment, { children: [shareInfo.subjectId && shareInfo.subjectId !== "-" && (_jsx(InfoRow, { label: t.subjectId, value: shareInfo.subjectId })), shareInfo.examDate && (_jsx(InfoRow, { label: t.examDate, value: dbDateHelper(shareInfo.examDate) })), shareInfo.aiModel && (_jsx(InfoRow, { label: t.aiModel, value: shareInfo.aiModel })), shareInfo.eye && (_jsx(InfoRow, { label: t.eye, value: shareInfo.eye })), shareInfo.expiresAt && (_jsx(InfoRow, { label: t.expiresAt, value: dbDateHelper(shareInfo.expiresAt) })), shareInfo.downloadLimit != null && (_jsx(InfoRow, { label: t.downloadLimit, value: String(shareInfo.downloadLimit) })), showPasswordField && (_jsxs(Box, { mt: 1.5, children: [_jsx(Typography, { variant: "caption", color: "text.secondary", align: "center", display: "block", sx: { mb: 1, px: 1, lineHeight: 1.4 }, children: t.passwordHint }), _jsx(SharePasswordInput, { value: password, onChange: function (next) {
                                                setPassword(next);
                                                if (downloadError)
                                                    setDownloadError("");
                                            }, disabled: isDownloading, isMobile: isMobile })] })), _jsx(Box, { display: "flex", justifyContent: "center", mt: 3, children: _jsx(Button, { variant: "contained", onClick: handleDownload, disabled: isDownloading, sx: {
                                            borderRadius: 0,
                                            minWidth: isMobile ? "100%" : 220,
                                            py: 1.2,
                                        }, children: isDownloading ? (_jsx(CircularProgress, { color: "inherit", size: 22 })) : (t.download) }) }), downloadError && (_jsx(Typography, { className: "small-text", color: "error", align: "center", sx: { mt: 2 }, children: downloadError }))] })), status === "expired" && (_jsx(Typography, { className: "normal-bold", color: "error", align: "center", py: 3, children: t.expired })), status === "error" && (_jsx(Typography, { className: "normal-bold", color: "error", align: "center", py: 3, children: t.error }))] }) }) }) }));
};
export default ShareReportPage;
